<div class="flex flex-row items-center justify-between w-full">
    <div class="pr-4 overflow-hidden w-2/5">
        <label class="!text-base">{{ 'projection' | transloco }}</label>
        <app-select
            [canClear]="false"
            [defaultValue]="defaultProjectionOption()"
            [isDisabled]="dataExportService.format() === ExportFormat.KML"
            [(options)]="projectionOptions"
            (optionSelected)="selectProjection($event)" />
    </div>
    <div class="overflow-hidden w-2/5">
        <label class="!text-base">{{ 'format' | transloco: { COUNT: 1 } }}</label>
        <app-select
            [canClear]="false"
            [defaultValue]="defaultFormatOption()"
            [(options)]="formatOptions"
            (optionSelected)="selectFormat($event)" />
    </div>
</div>
